APP_CONTAINER_VERSION = '16.0.21';
APP_CORE_VERSION = '16.0.12';
APP_CONTAINER_NAME = 'self-digital-fe';
APP_CORE_NAME = 'self-digital-core-fe';
